export default {
      id: "map__car_type_taxi-usage",
      viewBox: "0 0 32 33",
      url: __webpack_public_path__ + "img/icons.svg#map__car_type_taxi",
      toString: function () {
        return this.url;
      }
    }